import React, { useRef, useEffect } from 'react';
import { useTutorial } from '../../context/TutorialContext';

const TutorialTooltip = ({ id, title, description, className }) => {
  const anchorRef = useRef(null);
  const { registerTip, unregisterTip } = useTutorial();

  useEffect(() => {
    // Регистрируем подсказку с ref и всеми данными
    registerTip({ id, ref: anchorRef, title, description, className });
    // При размонтировании удаляем
    return () => unregisterTip(id);
  }, [id, title, description, className, registerTip, unregisterTip]);

  // Возвращаем только невидимый якорь. Он будет находиться ровно на том месте,
  // где раньше был визуальный тултип, и служить точкой привязки для портала.
  return <span ref={anchorRef} className={`tutorial-anchor ${className || ''}`} style={{ display: 'inline' }} />;
};

export default TutorialTooltip;